import { Box } from "@mui/material";

interface Props {
  width?: number;
  borderColor?: string;
  background?: string;
  children?: JSX.Element | JSX.Element[];
}

const gradientBG =
  "linear-gradient(96.38deg, rgba(0, 70, 255, 0.15) -23.54%, rgba(102, 137, 230, 0.13) 47.94%, rgba(95, 92, 209, 0.29) 118.6%)" as const;

export const BackgroundCircle = ({
  width = 200,
  borderColor = "#4E57AA",
  background = gradientBG,
  children,
}: Props): JSX.Element => {
  const padding = Math.floor(0.06 * width);
  return (
    <Box
      sx={{
        display: "flex",
        border: `solid 1px ${borderColor}`,
        borderRadius: "50%",
        p: `${padding}px`,
        width: width,
        height: width,
      }}
      className="BackgroundCircle"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          borderRadius: "50%",
          width: "100%",
          background: `${background}`,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
